import React from 'react'
import Grid from '@material-ui/core/Grid'
import CourseCard from './CourseCard'
import { Course as ICourse } from '../../../../types/academy'

interface Props {
  courses: ICourse[]
  type?: 'details'
}

function CourseGrid({ courses, type }: Props): JSX.Element {
  return (
    <Grid container justify="flex-start" spacing={2}>
      {courses.map((course) => (
        <Grid item key={course._id} xs={6} md={3}>
          <CourseCard course={course} type={type} />
        </Grid>
      ))}
    </Grid>
  )
}

export default CourseGrid
